module.exports = __webpack_public_path__ + "static/media/logo_pn_en.f85f6609.svg";